export default __webpack_public_path__ + "static/media/crystal1.510693a9.jpg";